<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body" id="addFeatureDialog">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">
        {{ t('manageEnrollment.batchReEnroll.title') }}
      </h1>
      <i
        mat-button
        mat-dialog-close
        class="text-drdpblue-300 cursor-pointer uil uil-times-circle"
      ></i>
    </div>

    @if (displayResult) {
      <div mat-dialog-content>
        @if (ratingOptions.length != 0) {
          <div class="content py-3">
            <p class="w-96">
              <em
                >{{ t('manageEnrollment.batchReEnroll.prerequisiteNotice') }}</em
                >
              </p>
              <div class="col-span-2 mt-2">
                <label class="font-normal mb-2" for="childName"
                  >{{ t('manageEnrollment.common.selectedChildren') }}</label
                  >
                  <ul>
                    @for (child of students; track child) {
                      <li>
                        <!-- Server-supplied: child name comes from the API. -->
                        {{ child.firstName + " " + child.lastName }}
                      </li>
                    }
                  </ul>
                </div>
                <form [formGroup]="reEnrollmentForm">
                  <div class="flex flex-row">
                    <div class="mr-12">
                      <label class="font-normal">{{
                        t('manageEnrollment.batchReEnroll.classroomLabel')
                      }}</label>
                      <!-- Server-supplied: classroom name comes from the API. -->
                      <p>{{ data.name }}</p>
                    </div>
                    <div class="w-64">
                      <label class="font-normal required">{{
                        t('manageEnrollment.batchReEnroll.ratingPeriodLabel')
                      }}</label>
                      <mat-select
                        [placeholder]="t('manageEnrollment.batchReEnroll.ratingPeriodPlaceholder')"
                        formControlName="ratingPeriodId"
                        (selectionChange)="handleRatingPeriod($event)"
                        >
                        @for (rating of ratingOptions; track rating) {
                          <mat-option
                            [value]="rating.id"
                            >
                            <!-- Server-supplied: rating period name comes from the API. -->
                            {{ rating.ratingPeriodName }}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </div>
                  @if (requireAgeGrade) {
                    <div class="flex flex-row">
                      <drdp-select-age-grade
                        [stateId]="data.stateId" [label]="t('manageEnrollment.common.ageGradeLabel')"
                        [multiSelect]="false"
                        [required]="true"
                        [isPilot]="true"
                        [schoolYearId]="selectedSchoolYearId"
                        (ageGrade)="handleAgeGrade($event)">
                      </drdp-select-age-grade>
                    </div>
                  }
                  <div class="grid grid-cols-2 gap-x-4 items-end">
                    <div class="relative">
                      <div class="col-span-1">
                        <drdp-date-picker [label]="t('manageEnrollment.batchReEnroll.classroomEndDateLabel')"
                          [initialDate]="classExitDate?.value"
                          labelClasses="pb-1"
                          [isRequired]="true"
                          (emitDate)="handleDate($event, 'classExitDate')">
                        </drdp-date-picker>
                      </div>
                      <div class="absolute top-0 left-full mt-1 ml-[-2px]">
                        <i class="uil uil-info-circle text-xs" [matTooltip]="t('manageEnrollment.batchReEnroll.endDateInfo')"></i>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="col-span-1">
                        <drdp-date-picker [label]="t('manageEnrollment.common.classroomEnrollmentDateLabel')"
                          [initialDate]="classEnrollmentDate?.value"
                          labelClasses="pb-1"
                          [isRequired]="true"
                          (emitDate)="handleDate($event, 'classEnrollmentDate')">
                        </drdp-date-picker>
                      </div>
                      <div class="absolute top-0 left-full mt-1 ml-[-2px]">
                        <i class="uil uil-info-circle text-xs" [matTooltip]="t('manageEnrollment.common.enrollmentDateInfo')"></i>
                      </div>
                    </div>
                  </div>
                  <div class="w-96">
                    @if (classEnrollmentDate.hasError('dateNotWithinRatingPeriod')) {
                      <mat-error>
                        {{ t('manageEnrollment.batchReEnroll.dateNotWithinRatingPeriodError') }}
                      </mat-error>
                    }
                    @if (reEnrollmentForm.hasError('dateMismatch')) {
                      <mat-error>
                        {{ t('manageEnrollment.batchReEnroll.dateMismatchError') }}
                      </mat-error>
                    }
                  </div>
                </form>
                <div class="pt-3">
                  <drdp-rating-periods [agencyId]="agencyId"></drdp-rating-periods>
                </div>
              </div>
            } @else {
              <div class="flex flex-row mt-2">
                <p>{{ t('manageEnrollment.batchReEnroll.noRatingPeriods') }}</p>
              </div>
            }
          </div>
        }
        <div class="spacer"></div>
        <div mat-dialog-actions class="flex flex-row justify-end">
          <drdp-btn color="cancel" class="mr-3" mat-button mat-dialog-close>
            {{ t('manageEnrollment.common.cancel') }}
          </drdp-btn>
          @if (ratingOptions.length > 0) {
            <drdp-btn
              color="blue"
        [disabled]="
          ratingOptions.length == 0 || isProcessing || reEnrollmentForm.invalid
        "
              mat-button
              (click)="submit()"
              >
              {{ submitBtnText }}
            </drdp-btn>
          }
        </div>
      </div>
</ng-container>
